import styles from '../custom-select.module.css';

import { ICONS } from '@ui/icons/types';
import RotatableIcon from '@ui/RotatableIcon/rotatable-icon';

const FakeBorder = ({ lockActiveState, menuOpen }: { lockActiveState: boolean; menuOpen: boolean }) => {
  return (
    <div
      className={`${styles['fake-border']} ${lockActiveState ? styles['show-fake-border'] : ''} ai-center jc-flex-end`}
    >
      <div className={`${styles['fake-dropdown-icon']} flex pi-center`}>
        <RotatableIcon name={ICONS.KEYBOARD_ARROW_DOWN} size={12} rotate={menuOpen ? '180deg' : '0'} />
      </div>
    </div>
  );
};

export default FakeBorder;
